import type { AppRoute } from 'src/routes/types';

import { Box, Drawer, Stack } from '@mui/material';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Logo from 'src/legacy/components/logo';
import { NavSectionVertical } from 'src/legacy/components/nav-section';
import Scrollbar from 'src/legacy/components/scrollbar';
import { NAV } from 'src/legacy/config-global';
import useResponsive from 'src/legacy/hooks/useResponsive';

import navConfig from './config-navigation';
import NavAccount from './NavAccount';
import NavToggleButton from './NavToggleButton';

// ----------------------------------------------------------------------

type Props = {
  onCloseNav: VoidFunction;
  openNav: boolean;
  privateAppRoutes: AppRoute[];
};

const NavVertical = ({ onCloseNav, openNav, privateAppRoutes }: Props) => {
  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        '& .simplebar-content': {
          display: 'flex',
          flexDirection: 'column',
          height: 1,
        },
        height: 1,
      }}
    >
      <Stack
        spacing={3}
        sx={{
          flexShrink: 0,
          pb: 2,
          pt: 3,
          px: 2.5,
        }}
      >
        <Logo />

        <NavAccount />
      </Stack>

      <NavSectionVertical data={navConfig(privateAppRoutes)} />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD },
      }}
    >
      <NavToggleButton />

      {isDesktop ? (
        <Drawer
          open
          PaperProps={{
            sx: {
              bgcolor: 'transparent',
              borderRightStyle: 'dashed',
              width: NAV.W_DASHBOARD,
              zIndex: 0,
            },
          }}
          variant="permanent"
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          ModalProps={{
            keepMounted: true,
          }}
          onClose={onCloseNav}
          open={openNav}
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
};

export default NavVertical;
